<template>
  <section class="form">
    <b-tabs type="is-toggle-rounded" class="px-2">
      <b-tab-item label="Add English Assessment">
        <add-english-assessment></add-english-assessment>
      </b-tab-item>
      <b-tab-item label="Add Maths Assessment">
        <add-maths-assessment></add-maths-assessment>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
 import addEnglish from "./BulkAddEnglishAssessmentComponent";
 import addMaths from "./BulkAddMathAssessmentComponent";

export default {
  name: "AddSubjectComponent",
  components: {
    "add-english-assessment": addEnglish,
    "add-maths-assessment": addMaths
  }
};
</script>
